import { createAxiosClient } from '../axiosDefaults';
export function createApi(baseURL, config) {
  let axiosConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const instance = createAxiosClient({
    baseURL,
    withCredentials: true,
    ...axiosConfig
  }, config);

  function getDoubleOptInConfig(hash) {
    return instance.get("/crm/template/" + hash + "/double_opt_in");
  }

  return {
    getDoubleOptInConfig
  };
}